import React from "react"
import PropTypes from "prop-types"

const SquareRoundedColorListLegend = ({
  containerClassName = "",
  data,
  onMouseEnter,
  onMouseLeave,
}) => {
  const uniqueElements = data.filter(
    (item, index, self) =>
      index === self.findIndex((obj) => obj.name === item.name) &&
      item.value !== 0 &&
      item.extraInfo?.label
  )
  return (
    <div className={`custom-recharts-legend ${containerClassName}`}>
      {uniqueElements?.map((item) => (
        <div
          key={item.name}
          className="flex gap-2 align-items-center"
          data-name={item.name}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <div
            className="border-round-md w-1rem h-1rem"
            style={{ background: item.color }}
          ></div>
          <span className="legend-text">{item.extraInfo.label}</span>
        </div>
      ))}
    </div>
  )
}

export default SquareRoundedColorListLegend

SquareRoundedColorListLegend.propTypes = {
  data: PropTypes.array,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
}
